<template lang="pug">
    div
        //BreadCrumb(:linkBreadCrumb="linkBreadCrumb")
        sub-families(
            :familyId="$route.params.id"
            v-if="$can('VIEW_ALL_PRODUCT_SUBFAMILY')"
            )
</template>

<script>
/* components */
import {
    CrudForm,
    BreadCrumb,
} from '@/components/reusable_components'
import Subfamilies from '@/views/Subfamily/SubfamilyList'
import RUTInput from '@/components/RUTInput/RUTInput'

/* mixins */
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import WholesaleDiscountRouterMixin from '@/mixins/WholesaleDiscountRoute.js'
/* services */
import CommuneService from '@/services/api/commune/CommuneService'
import FamilyServices from '@/services/api/family/FamilyServices'
import { addRUTHyphen, removeRUTHyphen } from '@/services/RUTFormatter'
/* vuex */
import { mapActions } from 'vuex'
export default {
    name: 'show-edit-family',
    // props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: [
                {
                    field: 'family',
                    type: 'text',
                    maxLength: 30,
                    value: '',
                    vuetifyProps: {
                        label: 'Nombre de Familia',
                    },
                    rules: ['required'],
                },
            ],
            //titulo
            staticData: null,

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            arrCommunes: null,
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Subfamilias',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        myFields() {
            return this.fields
        },
        buttonProp() {
            return {
                color: 'info',
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Familia'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return value.length >= 8 ? true : 'El largo mínimo es 8'
            }
            information.editable = true
            information.disabled = false
            information.submitText = 'Editar Familia'

            return information
        },
        async fillFields() {
            let communes = await CommuneService.fetchCommunes()
            let customerInfo = await FamilyServices.fetchFamily(
                this.$route.params.id
            )

            this.fields[0].value = customerInfo.family

            this.fields = JSON.parse(JSON.stringify(this.fields))
        },
    },
    // watch: {},
    components: {
        'crud-form': CrudForm,
        'sub-families': Subfamilies,
        BreadCrumb,
    },
    mixins: [InputValidations, CurrencyUtils, WholesaleDiscountRouterMixin],
    // filters: {},
    // -- Lifecycle Methods
    mounted() {
        this.staticData = this.fillStaticFormData()
        this.fillFields()
        this.setTitleTopBar('Detalle Familia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PRODUCT_FAMILY')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
.buttonCreate {
    margin-right: 280px;
}
</style>
